/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ActionNameEnum } from "./ActionNameEnum";
import {
  ActionNameEnumFromJSON,
  ActionNameEnumFromJSONTyped,
  ActionNameEnumToJSON,
  ActionNameEnumToJSONTyped,
} from "./ActionNameEnum";
import type { SimulationRunnerEnum } from "./SimulationRunnerEnum";
import {
  SimulationRunnerEnumFromJSON,
  SimulationRunnerEnumFromJSONTyped,
  SimulationRunnerEnumToJSON,
  SimulationRunnerEnumToJSONTyped,
} from "./SimulationRunnerEnum";

/**
 *
 * @export
 * @interface Action
 */
export interface Action {
  /**
   *
   */
  name: ActionNameEnum;
  /**
   * Only valid for name='start'. Run simulation for given duration (in seconds) and pause
   */
  duration?: number;
  /**
   * Only valid for name='pause'. Remove simulation after given timeout (in seconds). Defaults to 300 seconds
   */
  timeout?: number;
  /**
   * Only valid for name='start'. Limit maximum speed of the simulation. The max_rate is a multiplier relative to real time For example max_rate '60' means max 60 simulation seconds in 1 real second
   */
  maxRate?: number;
  /**
   * Only valid for name values: 'start', 'initialize' or 'queue' Compute cluster to start the session. If ommitted the first available cluster is used, starting with the default cluster.
   */
  computeCluster?: string;
  /**
   * Only allowed for name values: 'start', 'initialize' or 'queue Simulation runner version used to execute the simulation. If not filled in the default version is used. (Note: used for testing new calccore releases on the staging environment. On production only the default version can be picked)
   *
   * * `3.5.65-3.7.3` - 3.5.65-3.7.3
   * * `3.5.39-3.7.4.b0` - 3.5.39-3.7.4.b0
   */
  simulationRunner?: SimulationRunnerEnum;
}

/**
 * Check if a given object implements the Action interface.
 */
export function instanceOfAction(value: object): value is Action {
  if (!("name" in value) || value["name"] === undefined) return false;
  return true;
}

export function ActionFromJSON(json: any): Action {
  return ActionFromJSONTyped(json, false);
}

export function ActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Action {
  if (json == null) {
    return json;
  }
  return {
    name: ActionNameEnumFromJSON(json["name"]),
    duration: json["duration"] == null ? undefined : json["duration"],
    timeout: json["timeout"] == null ? undefined : json["timeout"],
    maxRate: json["max_rate"] == null ? undefined : json["max_rate"],
    computeCluster: json["compute_cluster"] == null ? undefined : json["compute_cluster"],
    simulationRunner:
      json["simulation_runner"] == null
        ? undefined
        : SimulationRunnerEnumFromJSON(json["simulation_runner"]),
  };
}

export function ActionToJSON(json: any): Action {
  return ActionToJSONTyped(json, false);
}

export function ActionToJSONTyped(
  value?: Action | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    name: ActionNameEnumToJSON(value["name"]),
    duration: value["duration"],
    timeout: value["timeout"],
    max_rate: value["maxRate"],
    compute_cluster: value["computeCluster"],
    simulation_runner: SimulationRunnerEnumToJSON(value["simulationRunner"]),
  };
}
